import {
  CustomFieldRecord,
  CustomFieldType,
  TargetEntityType,
} from "./CustomFieldRecord";

/** Keys understood by the shared `FieldTypeIcon` component. */
type FieldTypeIconKey = "string" | "numeric" | "date" | "boolean" | "enum";

// These keys are the `FilterDefinition` types the search builders map custom
// fields to, so the field-picker icon matches the Settings table by
// construction. Keyed by the full enum so a new member fails to compile until
// its icon key is added here.
const TYPE_ICON_KEYS: Record<CustomFieldType, FieldTypeIconKey> = {
  [CustomFieldType.String]: "string",
  [CustomFieldType.Number]: "numeric",
  [CustomFieldType.Timestamp]: "date",
  [CustomFieldType.Boolean]: "boolean",
  [CustomFieldType.Enum]: "enum",
};

export function customFieldTypeIconType(
  type: CustomFieldType,
): FieldTypeIconKey {
  return TYPE_ICON_KEYS[type];
}

/** Label shown for a field, defaulting to the field name when no display name is set. */
export function customFieldDisplayName(field: CustomFieldRecord): string {
  return field.display_name ?? field.field_name;
}

const ENTITY_TYPE_PLURALS: Record<TargetEntityType, string> = {
  [TargetEntityType.Collection]: "collections",
  [TargetEntityType.Dataset]: "datasets",
  [TargetEntityType.Device]: "devices",
  [TargetEntityType.Event]: "events",
  [TargetEntityType.Session]: "sessions",
};

/** Lowercase plural noun for an entity type, e.g. "sessions", for use mid-sentence. */
export function customFieldEntityTypePlural(
  entityType: TargetEntityType,
): string {
  return ENTITY_TYPE_PLURALS[entityType];
}

const ENTITY_TYPE_SINGULARS: Record<TargetEntityType, string> = {
  [TargetEntityType.Collection]: "collection",
  [TargetEntityType.Dataset]: "dataset",
  [TargetEntityType.Device]: "device",
  [TargetEntityType.Event]: "event",
  [TargetEntityType.Session]: "session",
};

/** Lowercase singular noun for an entity type, e.g. "session", for use mid-sentence. */
export function customFieldEntityTypeSingular(
  entityType: TargetEntityType,
): string {
  return ENTITY_TYPE_SINGULARS[entityType];
}
